// extracted by mini-css-extract-plugin
export default {"titleWrap":"product-title_titleWrap__1UjcS","title":"product-title_title__a4o7S","breadcrumb":"product-title_breadcrumb__2DVYm"};